import { render, staticRenderFns } from "./PracticalWork.vue?vue&type=template&id=5d3262ba"
import script from "./PracticalWork.vue?vue&type=script&lang=js"
export * from "./PracticalWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports